import { render, staticRenderFns } from "./getpsc-box2.vue?vue&type=template&id=9ecb33d6&scoped=true&"
import script from "./getpsc-box2.vue?vue&type=script&lang=js&"
export * from "./getpsc-box2.vue?vue&type=script&lang=js&"
import style0 from "./getpsc-box2.vue?vue&type=style&index=0&id=9ecb33d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb33d6",
  null
  
)

export default component.exports